"use client";

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader, CardTitle } from "@/src/components/shadcn/ui/card";
import { AthenaCoverageEvidence } from "@/src/components/tasks/approval-types/athena-coverage-evidence";
import { ReferralMatchEvidence } from "@/src/components/tasks/approval-types/referral-match-evidence";
import { ApprovalType, type TaskApproval } from "@/src/models/task-approval";
function EvidenceContent(t0) {
  const $ = _c(26);
  const {
    approval
  } = t0;
  switch (approval.approvalType) {
    case ApprovalType.REFERRAL_MATCH:
      {
        let t1;
        if ($[0] !== approval.metadata) {
          t1 = <ReferralMatchEvidence metadata={approval.metadata} />;
          $[0] = approval.metadata;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case ApprovalType.ATHENA_COVERAGE:
      {
        if (!approval.metadata) {
          let t1;
          if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = <p className="text-sm text-destructive">Coverage confirmation details are unavailable.</p>;
            $[2] = t1;
          } else {
            t1 = $[2];
          }
          return t1;
        }
        let t1;
        if ($[3] !== approval.metadata.instruction) {
          t1 = <p>{approval.metadata.instruction}</p>;
          $[3] = approval.metadata.instruction;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        let t2;
        if ($[5] !== approval.metadata) {
          t2 = <AthenaCoverageEvidence metadata={approval.metadata} />;
          $[5] = approval.metadata;
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        let t3;
        if ($[7] !== t1 || $[8] !== t2) {
          t3 = <div className="space-y-3 text-sm">{t1}{t2}</div>;
          $[7] = t1;
          $[8] = t2;
          $[9] = t3;
        } else {
          t3 = $[9];
        }
        return t3;
      }
    case ApprovalType.TPR_RECEIVING_ASSIGNMENT:
      {
        if (!approval.metadata) {
          let t1;
          if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = <p className="text-sm text-destructive">Receiving assignment details are unavailable.</p>;
            $[10] = t1;
          } else {
            t1 = $[10];
          }
          return t1;
        }
        let t1;
        if ($[11] !== approval.metadata.instruction) {
          t1 = <p>{approval.metadata.instruction}</p>;
          $[11] = approval.metadata.instruction;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        let t2;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <strong>Provider:</strong>;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        const t3 = approval.metadata.providerName ?? "N/A";
        let t4;
        if ($[14] !== t3) {
          t4 = <p>{t2} {t3}</p>;
          $[14] = t3;
          $[15] = t4;
        } else {
          t4 = $[15];
        }
        let t5;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <strong>Department:</strong>;
          $[16] = t5;
        } else {
          t5 = $[16];
        }
        const t6 = approval.metadata.targetDepartmentId ?? "N/A";
        let t7;
        if ($[17] !== t6) {
          t7 = <p>{t5} {t6}</p>;
          $[17] = t6;
          $[18] = t7;
        } else {
          t7 = $[18];
        }
        let t8;
        if ($[19] !== t1 || $[20] !== t4 || $[21] !== t7) {
          t8 = <div className="space-y-3 text-sm">{t1}{t4}{t7}</div>;
          $[19] = t1;
          $[20] = t4;
          $[21] = t7;
          $[22] = t8;
        } else {
          t8 = $[22];
        }
        return t8;
      }
    case ApprovalType.TPR_REFERRAL_OPS:
      {
        if (!approval.metadata) {
          let t1;
          if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = <p className="text-sm text-destructive">Referral operations details are unavailable.</p>;
            $[23] = t1;
          } else {
            t1 = $[23];
          }
          return t1;
        }
        let t1;
        if ($[24] !== approval.metadata.instruction) {
          t1 = <p className="text-sm">{approval.metadata.instruction}</p>;
          $[24] = approval.metadata.instruction;
          $[25] = t1;
        } else {
          t1 = $[25];
        }
        return t1;
      }
    default:
      {
        const _exhaustive = approval;
        return _exhaustive;
      }
  }
}
export function ApprovalEvidenceCard(t0) {
  const $ = _c(3);
  const {
    approval
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CardHeader><CardTitle className="text-center">Action Pending Review</CardTitle></CardHeader>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== approval) {
    t2 = <Card className="bg-warn/5 border border-warn/20">{t1}<CardContent><EvidenceContent approval={approval} /></CardContent></Card>;
    $[1] = approval;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}